
const INPUT_FIELD_HEIGHT = "32px"; // Adjust this to match your input height

const skeletonAnimation = `
@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
`;

export const InputLoading = () => {
  const skeletonStyles = {
    baseColor: "#EEEEEE",
    movingColor:
      "linear-gradient(to right, transparent 0%, #FDFDFD 50%, transparent 100%)",
  };

  return (
    <>
      <style>{skeletonAnimation}</style>
      <div
        className="w-full rounded-[4px]"
        style={{
          height: INPUT_FIELD_HEIGHT,
          backgroundColor: skeletonStyles.baseColor,
          backgroundImage: skeletonStyles.movingColor,
          backgroundSize: "200% 100%",
          animation: "skeleton-shimmer 2.5s infinite linear",
        }}
      />
    </>
  );
};
